import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { RetailerUser } from '../services/authService';

interface MainLayoutProps {
  cartCount: number;
  onCartClick: () => void;
  onLoginClick: () => void;
  retailerUser: RetailerUser | null;
  onLogout: () => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({ cartCount, onCartClick, onLoginClick, retailerUser, onLogout }) => (
  <>
    <Navigation
      cartCount={cartCount}
      onCartClick={onCartClick}
      onLoginClick={onLoginClick}
      retailerUser={retailerUser}
      onLogout={onLogout}
    />
    <main>
      <Outlet />
    </main>
    <Footer />
  </>
);

export default MainLayout;
